<template>
  <div class="index_container">
    <div class="banner_box header-width">
      <banner></banner>
    </div>
    <div class="index_content">
      <indexcontent></indexcontent>
    </div>
  </div>
</template>
<script>
  import indexcontent from "@/components/contentcoms/indexcontentcoms/indexcontent"
  import banner from "@/components/commoncoms/banner"

  export default {
    components: {
      indexcontent,
      banner
    },
     created() {
    
  },
  methods: {

  }
  }
</script>



// WEBPACK FOOTER //
// src/pages/index.vue